import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat WhatsApp PT. SINAR AL MUBAROKAH"
    data-testid="whatsapp-floating-button"
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.8, type: "spring", stiffness: 200, damping: 15 }}
    className="fixed bottom-6 right-6 z-50 flex h-16 w-16 items-center justify-center rounded-full text-white shadow-2xl transition-transform duration-300 hover:scale-110"
    style={{ backgroundColor: "#25D366" }}
  >
    <span className="absolute inset-0 animate-ping rounded-full" style={{ backgroundColor: "rgba(37,211,102,0.35)" }} />
    <MessageCircle size={28} className="relative" />
  </motion.a>
);
